(function () {
  'use strict';
  var drawer = document.getElementById('CartDrawer');
  if (!drawer) return;

  var itemsEl = drawer.querySelector('[data-cart-items]');
  var emptyEl = drawer.querySelector('[data-cart-empty]');
  var footerEl = drawer.querySelector('[data-cart-footer]');
  var subtotalEl = drawer.querySelector('[data-cart-subtotal]');
  var mrpEl = drawer.querySelector('[data-cart-mrp]');
  var moneyFormat = drawer.getAttribute('data-money-format') || '₹{{amount}}';

  var fbtCollection = drawer.getAttribute('data-fbt-collection');
  var stealCollection = drawer.getAttribute('data-steal-collection');
  var stealThreshold = (parseInt(drawer.getAttribute('data-steal-threshold'), 10) || 0) * 100;
  var MIN_ORDER = (parseInt(drawer.getAttribute('data-min-order'), 10) || 0) * 100;
  var siddhiHandle = drawer.getAttribute('data-siddhi-handle');
  var REPORT_FEE_VID = parseInt(drawer.getAttribute('data-report-fee-id'), 10) || 0;
  var tiers = [];
  [['data-t1a', 'data-t1l'], ['data-t2a', 'data-t2l'], ['data-t3a', 'data-t3l']].forEach(function (p) {
    var a = (parseInt(drawer.getAttribute(p[0]), 10) || 0) * 100;
    var l = drawer.getAttribute(p[1]) || '';
    if (a > 0 && l) tiers.push([a, l]);
  });
  tiers.sort(function (a, b) { return a[0] - b[0]; });

  /* ===== Concurrency control ===== */
  var opSeq = 0;
  var chain = Promise.resolve();
  var queued = 0;
  function enqueue(fn) {
    queued++;
    var run = function () { return Promise.resolve().then(fn).catch(function () {}).then(function (v) { queued--; return v; }); };
    chain = chain.then(run, run);
    return chain;
  }
  function commit(cart, seq) {
    if (!cart || typeof cart.item_count === 'undefined') return warmedCart;
    if (seq !== opSeq) return warmedCart; /* stale — ignore */
    if (!cart.__dhPartial) lastFull = cart;
    warmedCart = cart;
    render(cart);
    return cart;
  }

  /* ===== Steal Deal rules =====
     - Display pricing: _steal_deal property lines shown at STEAL_PCT off (whole rupees).
     - Unlock + checkout eligibility are based on the REGULAR (non-steal) subtotal, so
       removing regular items re-locks the deal and blocks checkout while steal items remain.
     - Steal lines are fixed at qty 1 (no +/- control, server-clamped).
     - The steal rail never shows products already in the cart. */
  var STEAL_PCT = 30;
  var STEAL_CODE = 'STEALDEAL30';
  function stealDealPrice(cents, pct) {
    return Math.round(cents * (100 - pct) / 100 / 100) * 100;
  }
  function stealPctOf(item) {
    var p = (item && item.properties && item.properties._steal_deal) ? parseInt(item.properties._steal_deal, 10) : 0;
    return (p > 0 && p < 100) ? p : 0;
  }
  /* True once Shopify has applied the STEALDEAL30 code to this line server-side —
     from then on final_line_price is ALREADY the discounted price. */
  function stealApplied(item) {
    return ((item && item.line_level_discount_allocations) || []).length > 0;
  }
  function stealSavings(cart) {
    /* Only the savings NOT yet baked into cart.total_price (code hasn't landed on the
       line). Once Shopify applies the code, the discount is inside total_price and
       final_line_price, so counting it again here would double-discount the display. */
    var s = 0;
    ((cart && cart.items) || []).forEach(function (it) {
      var p = stealPctOf(it);
      if (p && !stealApplied(it)) s += it.final_line_price - stealDealPrice(it.final_line_price, p);
    });
    return s;
  }
  function normalSubtotal(cart) {
    var s = 0;
    ((cart && cart.items) || []).forEach(function (it) { if (!stealPctOf(it)) s += it.final_line_price; });
    return s;
  }
  function hasStealItems(cart) {
    return ((cart && cart.items) || []).some(function (it) { return stealPctOf(it) > 0; });
  }
  function stealBlocked(cart) {
    return hasStealItems(cart) && normalSubtotal(cart) < stealThreshold;
  }

  var lastTotalCents = 0;
  var lastCount = 0;
  var inflight = 0; /* units added but not yet confirmed by Shopify (see "fast adds") */
  var lastFull = null; /* last cart read from /cart.js or /cart/change.js (all fields) */
  var warmedCart = null;
  var vmeta = {};
  var vmetaPending = {};
  var fbtProducts = null;
  var stealProducts = null;
  var siddhiVariant = null, siddhiPrice = 0;
  var stealWasUnlocked = false;
  var booted = false;
  try { vmeta = JSON.parse(sessionStorage.getItem('dh_vmeta') || '{}'); } catch (e) { vmeta = {}; }

  /* ---------- money ---------- */
  function formatMoney(cents) {
    var value = (cents / 100);
    var hasFraction = Math.round(cents) % 100 !== 0;
    var num = hasFraction ? value.toFixed(2) : Math.round(value).toString();
    var parts = num.split('.');
    var x = parts[0];
    var lastThree = x.length > 3 ? x.slice(-3) : x;
    var otherNumbers = x.length > 3 ? x.slice(0, -3) : '';
    if (otherNumbers) lastThree = ',' + lastThree;
    var grouped = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastThree;
    var out = grouped + (parts[1] ? '.' + parts[1] : '');
    if (moneyFormat.indexOf('{{amount}}') !== -1) return moneyFormat.replace('{{amount}}', out);
    if (moneyFormat.indexOf('{{amount_no_decimals}}') !== -1) return moneyFormat.replace('{{amount_no_decimals}}', grouped);
    return '₹' + out;
  }
  function esc(s) { return (s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* ---------- open / close ---------- */
  function openCart() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('cart-open');
    boot();
  }
  function closeCart() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('cart-open');
  }
  window.DivineCart = { open: openCart, close: closeCart, refresh: refresh };

  /* ---------- render ---------- */
  function updateCounts(count) {
    lastCount = count;
    document.querySelectorAll('[data-cart-count], .header-cart-count').forEach(function (el) { el.textContent = count; });
  }
  function imgThumb(src) { return src ? src.replace(/(\.[^.\/?]+)(\?|$)/, '_180x180$1$2') : ''; }

  var trashSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M3 6h18M8 6V4h8v2M6 6l1 15h10l1-15M10 10v7M14 10v7"/></svg>';

  function lineHTML(item) {
    var compare = '';
    if (item.original_line_price > item.final_line_price) {
      compare = '<span class="cart-line__compare">' + formatMoney(item.original_line_price) + '</span>';
    } else {
      var m = vmeta[item.variant_id];
      /* only strike through an MRP at least 1% above the price — a near-identical
         strikethrough (₹29,998 next to ₹29,982) reads as a rendering glitch */
      if (m && m >= item.original_price * 1.01) compare = '<span class="cart-line__compare">' + formatMoney(m * item.quantity) + '</span>';
    }
    var variant = (item.variant_title && item.variant_title !== 'Default Title') ? '<span class="cart-line__variant">' + esc(item.variant_title) + '</span>' : '';
    /* Rakhi Utsav lines: show each chosen design as a chip (name + mini photo from the
       hidden _Rakhi N Img property) so the customer sees BOTH rakhis in the drawer */
    var propsHtml = '';
    if (item.properties) {
      var chips = [];
      Object.keys(item.properties).forEach(function (k) {
        if (!/^(?:Rakhi|Rashi) \d+$/.test(k) || !item.properties[k]) return;
        var im = item.properties['_' + k + ' Img'];
        chips.push('<span class="cart-line__pchip">' + (im ? '<img src="' + esc(im) + '" alt="" width="26" height="26" loading="lazy">' : '') + '<i>' + esc(String(item.properties[k])) + '</i></span>');
      });
      if (chips.length) propsHtml = '<div class="cart-line__props">' + chips.join('') + '</div>';
    }
    if (item.properties && item.properties.Puja) {
      var bookingDetails = Object.keys(item.properties).filter(function(k){return /^(Puja|Package|Schedule|Gotra|Temple|Participant \d+|Name \d+|Gotra \d+)$/.test(k);});
      propsHtml += '<details class="cart-line__booking"><summary>Review sankalp details</summary>' + bookingDetails.map(function(k){return '<div><b>'+esc(k)+':</b> '+esc(String(item.properties[k]))+'</div>';}).join('') + '</details>';
    }
    var img = item.image ? '<img class="cart-line__img" src="' + imgThumb(item.image) + '" alt="" width="64" height="64" loading="lazy">' : '<span class="cart-line__img"></span>';
    var sp = stealPctOf(item);
    var priceHtml, qtyHtml;
    if (sp) {
      /* If the discount code already landed on this line, final_line_price IS the deal
         price — show it as-is with the pre-code price struck. Only pre-visualize the
         percentage when the code hasn't applied yet. */
      var applied = stealApplied(item);
      var deal = applied ? item.final_line_price : stealDealPrice(item.final_line_price, sp);
      var wasPrice = applied ? (item.original_line_price || item.final_line_price) : item.final_line_price;
      priceHtml = '<span class="cart-line__price cart-line__price--steal">' + formatMoney(deal) +
        (wasPrice > deal ? '<span class="cart-line__compare">' + formatMoney(wasPrice) + '</span>' : '') +
        '<em class="cart-line__stealchip">Steal ' + sp + '% OFF</em></span>';
      qtyHtml = '<span class="cart-line__qtylock" title="Steal Deal items are limited to 1">Qty 1 · Steal</span>';
    } else if (feeLockActive && isFeeLine(item)) {
      /* Fee is locked to the reports in the cart — no +/- and no remove while a report is present. */
      priceHtml = '<span class="cart-line__price">' + formatMoney(item.final_line_price) + compare + '</span>';
      qtyHtml = '<span class="cart-line__qtylock" title="A ₹99 processing fee applies to each report — it can’t be removed while a report is in your cart">&#215;' + item.quantity + ' · Required</span>';
    } else {
      priceHtml = '<span class="cart-line__price">' + formatMoney(item.final_line_price) + compare + '</span>';
      qtyHtml = '<span class="qty">' +
          '<button type="button" data-qty-down aria-label="Decrease">&minus;</button>' +
          '<span>' + item.quantity + '</span>' +
          '<button type="button" data-qty-up aria-label="Increase">+</button>' +
        '</span>';
    }
    return '' +
      '<div class="cart-line" data-key="' + item.key + '" data-handle="' + esc(item.handle) + '">' +
        img +
        '<div class="cart-line__info">' +
          '<a class="cart-line__title" href="' + item.url + '">' + esc(item.product_title) + '</a>' +
          variant +
          propsHtml +
          '<div class="cart-line__row">' +
            priceHtml +
            qtyHtml +
          '</div>' +
          ((feeLockActive && isFeeLine(item)) ? '' : '<button type="button" class="cart-line__remove" data-remove aria-label="Remove">' + trashSvg + '</button>') +
        '</div>' +
      '</div>';
  }

  /* ---------- payment summary / mrp ---------- */
  function setTxt(sel, v) { var el = drawer.querySelector(sel); if (el) el.textContent = v; }
  function summarize(cart) {
    var mrp = 0, sub = 0, siddhi = 0;
    cart.items.forEach(function (it) {
      var unit = it.original_price;
      var cmp = vmeta[it.variant_id];
      mrp += Math.max(cmp || 0, unit) * it.quantity;
      sub += it.final_line_price;
      if (it.handle === siddhiHandle) siddhi += it.final_line_price;
    });
    var coupon = Math.max(0, sub - cart.total_price);
    var steal = stealSavings(cart);
    var displayTotal = Math.max(0, cart.total_price - steal);
    setTxt('[data-sum-mrp]', formatMoney(mrp));
    setTxt('[data-sum-disc]', '-' + formatMoney(Math.max(0, mrp - sub)));
    setTxt('[data-sum-sub]', formatMoney(sub));
    setTxt('[data-sum-coupon]', '-' + formatMoney(coupon));
    setTxt('[data-sum-steal]', '-' + formatMoney(steal));
    var sr = drawer.querySelector('[data-steal-row]');
    if (sr) sr.hidden = steal <= 0;
    setTxt('[data-sum-siddhi]', formatMoney(siddhi));
    setTxt('[data-sum-total]', formatMoney(displayTotal));
    if (mrpEl) {
      if (mrp > displayTotal) { mrpEl.hidden = false; mrpEl.textContent = formatMoney(mrp); }
      else { mrpEl.hidden = true; }
    }
  }
  function saveMeta() { try { sessionStorage.setItem('dh_vmeta', JSON.stringify(vmeta)); } catch (e) {} }
  function seedMeta(products) {
    (products || []).forEach(function (p) {
      (p.variants || []).forEach(function (v) {
        var cmp = v.compare_at_price;
        if (cmp === null || cmp === undefined || cmp === '') return;
        var cents = (typeof cmp === 'number') ? cmp : Math.round(parseFloat(cmp) * 100);
        if (cents > 0) vmeta[v.id] = cents;
      });
    });
    saveMeta();
  }
  function ensureMeta(cart) {
    var handles = {};
    cart.items.forEach(function (it) {
      if (vmeta[it.variant_id] === undefined && it.handle && !vmetaPending[it.handle]) { handles[it.handle] = 1; }
    });
    var list = Object.keys(handles);
    if (!list.length) return;
    Promise.all(list.map(function (h) {
      vmetaPending[h] = 1;
      return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (prods) {
      var got = false;
      prods.forEach(function (p) {
        if (!p) return;
        (p.variants || []).forEach(function (v) { vmeta[v.id] = v.compare_at_price || 0; got = true; });
      });
      cart.items.forEach(function (it) { if (vmeta[it.variant_id] === undefined) vmeta[it.variant_id] = 0; });
      saveMeta();
      if (got && warmedCart) { summarize(warmedCart); paintLines(warmedCart); }
    });
  }
  function paintLines(cart) { if (cart.item_count > 0) { feeLockActive = hasReports(cart); itemsEl.innerHTML = cart.items.map(lineHTML).join(''); } }

  /* ---------- inline notice ---------- */
  function showCartNotice(msg) {
    var n = document.createElement('div');
    n.setAttribute('style', 'margin:0 5px 10px;background:#fdecea;border:1px solid #f5c6c2;color:#b02a1e;font-size:12.5px;font-weight:700;border-radius:10px;padding:10px 12px;text-align:center;');
    n.textContent = msg;
    itemsEl.insertAdjacentElement('afterbegin', n);
    setTimeout(function () { n.remove(); }, 3000);
  }

  /* ---------- combo meter ---------- */
  function updateCombo(total) {
    var fill = drawer.querySelector('[data-combo-fill]');
    var msg = drawer.querySelector('[data-combo-msg]');
    if (!fill || !msg || !tiers.length) return;
    var max = tiers[tiers.length - 1][0];
    fill.style.width = Math.min(100, Math.round(total / max * 100)) + '%';
    var next = null;
    for (var i = 0; i < tiers.length; i++) { if (total < tiers[i][0]) { next = tiers[i]; break; } }
    if (next) { msg.textContent = 'Add ' + formatMoney(next[0] - total) + ' more to unlock ' + next[1]; }
    else { msg.textContent = '🎉 All combo rewards unlocked!'; }
  }

  /* ---------- steal deals ---------- */
  function updateSteal(regularTotal) {
    var box = drawer.querySelector('[data-steal]');
    if (!box) return;
    var title = box.querySelector('[data-steal-title]');
    var sub = box.querySelector('[data-steal-sub]');
    var head = box.querySelector('[data-steal-toggle]');
    var base = box.getAttribute('data-title-base') || (title ? title.textContent.replace(/ Unlocked$/, '') : 'Steal Deal');
    box.setAttribute('data-title-base', base);
    var unlocked = regularTotal >= stealThreshold;
    if (head) head.disabled = !unlocked;
    if (!unlocked) box.classList.add('is-collapsed');
    if (title) title.textContent = unlocked ? base + ' Unlocked' : base;
    if (sub) {
      if (!unlocked) {
        sub.textContent = 'Add ' + formatMoney(stealThreshold - regularTotal) + ' more (regular items) to unlock the ' + base;
        sub.hidden = false;
      } else if (box.classList.contains('is-collapsed')) {
        sub.textContent = 'Unlocked — ' + STEAL_PCT + '% OFF · tap to view your deals';
        sub.hidden = false;
      } else {
        sub.hidden = true;
      }
    }
    var track = box.querySelector('[data-steal-track]');
    if (track) track.style.display = unlocked ? '' : 'none';
    if (unlocked && !stealWasUnlocked) {
      stealWasUnlocked = true;
      loadSteal();
      box.classList.remove('is-unlocked-flash');
      void box.offsetWidth;
      box.classList.add('is-unlocked-flash');
      setTimeout(function () { box.classList.remove('is-unlocked-flash'); }, 3600);
    }
    if (!unlocked) { stealWasUnlocked = false; box.classList.remove('is-unlocked-flash'); }
  }
  function stealCardHTML(p) {
    var v = p.variants && p.variants[0]; if (!v) return '';
    var price = Math.round(parseFloat(v.price) * 100);
    var deal = stealDealPrice(price, STEAL_PCT);
    var img = (p.images && p.images[0] && (p.images[0].src || p.images[0])) || '';
    return '<div class="cd2-scard">' +
      (img ? '<img src="' + imgThumb(img) + '" alt="" loading="lazy">' : '<span></span>') +
      '<div class="cd2-scard__in">' +
        '<a class="cd2-scard__t" href="/products/' + p.handle + '">' + esc(p.title) + '</a>' +
        '<span class="cd2-scard__p"><span class="stl-now">' + formatMoney(deal) + '</span><s>' + formatMoney(price) + '</s><em class="stl-chip">' + STEAL_PCT + '% OFF</em></span>' +
        '<button type="button" data-add-variant="' + v.id + '" data-claim data-steal-item>Claim Now</button>' +
      '</div></div>';
  }
  /* The rail hides anything already in the cart (added normally OR claimed). */
  function renderStealRail(cart) {
    var track = drawer.querySelector('[data-steal-track]');
    var box = drawer.querySelector('[data-steal]');
    if (!track || !stealProducts) return;
    var inCart = {};
    ((cart && cart.items) || []).forEach(function (it) { inCart[it.handle] = 1; });
    var list = stealProducts.filter(function (p) { return !inCart[p.handle]; });
    track.innerHTML = list.length
      ? list.map(stealCardHTML).join('')
      : '<div style="padding:14px 12px;font-size:12.5px;font-weight:700;color:#8a6d2f;">All Steal Deals claimed 🎉</div>';
    var collapsed = box && box.classList.contains('is-collapsed');
    var locked = box && box.querySelector('[data-steal-toggle]') && box.querySelector('[data-steal-toggle]').disabled;
    drawer.querySelectorAll('.cd2-snav').forEach(function (b) { b.hidden = list.length < 2 || collapsed || locked; });
  }
  function loadSteal() {
    if (stealProducts || !stealCollection) return;
    fetch('/collections/' + stealCollection + '/products.json?limit=10')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d || !d.products) return;
        stealProducts = d.products.filter(function (p) { return p.variants && p.variants.length && p.variants[0].available !== false; });
        seedMeta(stealProducts);
        renderStealRail(warmedCart);
      }).catch(function () {});
  }
  /* Steal lines are fixed at qty 1 — clamp any drift. */
  var clampingSteal = false;
  function clampSteal(cart) {
    if (clampingSteal || !cart || !cart.items) return;
    var ln = null;
    cart.items.forEach(function (it) { if (stealPctOf(it) && it.quantity > 1) ln = it; });
    if (ln) {
      clampingSteal = true;
      changeQty(ln.key, 1).then(function () { clampingSteal = false; });
    }
  }
  /* ===== Report processing fee: stays tied to the reports in the cart =====
     Every ₹1 report requires one ₹99 processing fee. The fee line is a shadow of the
     report count: it can't be independently removed or edited while any report is in the
     cart (see lineHTML + the click guard), and its quantity always follows the number of
     report units — dropping to 0 (removed) only once the last report is gone. GoKwik
     untouched: this only issues standard /cart/change.js edits, exactly like the steal clamp. */
  function isFeeLine(it) { return !!it && (it.product_type === 'Fee' || it.handle === 'report-processing-fee'); }
  function isReportLine(it) { return !!it && it.product_type === 'Astrology Report'; }
  function reportUnits(cart) { var n = 0; ((cart && cart.items) || []).forEach(function (it) { if (isReportLine(it)) n += it.quantity; }); return n; }
  function feeLineOf(cart) { var f = null; ((cart && cart.items) || []).forEach(function (it) { if (isFeeLine(it)) f = it; }); return f; }
  function hasReports(cart) { return reportUnits(cart) > 0; }
  var feeLockActive = false;   /* set per-render in paintLines: true when a report is in the cart */
  var syncingFee = false;
  function syncReportFee(cart) {
    if (syncingFee || !cart || !cart.items) return;
    var n = reportUnits(cart);        /* one ₹99 unit per report unit */
    var fee = feeLineOf(cart);
    var have = fee ? fee.quantity : 0;
    if (have === n) return;           /* already in sync */
    syncingFee = true;
    var done = function () { syncingFee = false; };
    if (fee) {
      /* adjust an existing fee — n === 0 removes it once the last report is gone */
      changeQty(fee.key, n).then(done);
    } else if (n > 0 && REPORT_FEE_VID) {
      /* a report is in the cart with NO fee at all (added by a flow that didn't include it) — add it */
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: REPORT_FEE_VID, quantity: n }] })
      }).then(function () { return refresh(); }).then(done, done);
    } else {
      done();
    }
  }
  /* Minimum-order gate: block checkout below MIN_ORDER. GoKwik untouched — this only toggles
     the theme's own Confirm anchor, exactly like the steal gate below already does. */
  function belowMin(cart) { return MIN_ORDER > 0 && cart && (cart.total_price || 0) < MIN_ORDER; }
  /* Checkout gate: steal items need the regular subtotal to stay above the unlock amount. */
  function updateCheckoutGate(cart) {
    var blocked = stealBlocked(cart) || belowMin(cart);
    var ck = drawer.querySelector('[data-cart-checkout]');
    if (ck) ck.classList.toggle('is-blocked', blocked);
    var warn = drawer.querySelector('[data-steal-warn]');
    if (warn) {
      warn.hidden = !blocked;
      if (stealBlocked(cart)) {
        var short = stealThreshold - normalSubtotal(cart);
        warn.textContent = '⚠️ Steal Deal items need ' + formatMoney(short) + ' more of regular products to checkout — add regular items or remove the Steal Deal items.';
      } else if (belowMin(cart)) {
        warn.textContent = '🛒 Add ' + formatMoney(MIN_ORDER - (cart.total_price || 0)) + ' more to checkout — minimum order is ' + formatMoney(MIN_ORDER) + '.';
      }
    }
  }

  /* ---------- frequently bought together ---------- */
  function fbtCardHTML(p) {
    var v = p.variants && p.variants[0]; if (!v) return '';
    var price = Math.round(parseFloat(v.price) * 100);
    var cmp = v.compare_at_price ? Math.round(parseFloat(v.compare_at_price) * 100) : 0;
    if (cmp < price * 1.01) cmp = 0; /* ignore near-identical MRPs — a ~0% strikethrough reads as a glitch */
    var off = cmp > price ? Math.round((1 - price / cmp) * 100) : 0;
    var img = (p.images && p.images[0] && (p.images[0].src || p.images[0])) || '';
    var chip = (v.title && v.title !== 'Default Title') ? '<span class="cd2-vchip">' + esc(v.title) + '</span>' : '';
    return '<div class="cd2-pcard">' +
      '<a class="cd2-pcard__media" href="/products/' + p.handle + '">' +
        (img ? '<img src="' + imgThumb(img).replace('_180x180', '_360x360') + '" alt="" loading="lazy">' : '') +
        (off ? '<span class="cd2-off">' + off + '% OFF</span>' : '') + chip +
      '</a>' +
      '<div class="cd2-pcard__body">' +
        '<a class="cd2-pcard__title" href="/products/' + p.handle + '">' + esc(p.title) + '</a>' +
        '<span class="cd2-pcard__price">' + formatMoney(price) + (cmp > price ? '<s>' + formatMoney(cmp) + '</s>' : '') + '</span>' +
        '<button type="button" data-add-variant="' + v.id + '">Add to Cart</button>' +
      '</div></div>';
  }
  function renderFBT(cart) {
    var box = drawer.querySelector('[data-fbt]');
    var track = drawer.querySelector('[data-fbt-track]');
    if (!box || !track || !fbtProducts) return;
    var inCart = {};
    (cart ? cart.items : []).forEach(function (it) { inCart[it.handle] = 1; });
    var list = fbtProducts.filter(function (p) { return !inCart[p.handle]; }).slice(0, 8);
    box.hidden = list.length === 0;
    track.innerHTML = list.map(fbtCardHTML).join('');
  }
  function loadFBT() {
    if (fbtProducts || !fbtCollection) return;
    fetch('/collections/' + fbtCollection + '/products.json?limit=12')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d || !d.products) return;
        fbtProducts = d.products.filter(function (p) { return p.variants && p.variants.length && p.variants[0].available !== false; });
        seedMeta(fbtProducts);
        renderFBT(warmedCart);
      }).catch(function () {});
  }

  /* ---------- siddhi add-on ---------- */
  function initSiddhi() {
    var row = drawer.querySelector('[data-siddhi]');
    if (!row || siddhiVariant || !siddhiHandle) return;
    fetch('/products/' + siddhiHandle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.variants || !p.variants.length) return;
        var cheapest = p.variants[0];
        p.variants.forEach(function (v) { if (v.price < cheapest.price) cheapest = v; });
        siddhiVariant = cheapest.id;
        siddhiPrice = cheapest.price;
        var pl = drawer.querySelector('[data-siddhi-price]');
        if (pl) pl.textContent = (p.variants.length > 1 ? 'from ' : '+ ') + formatMoney(siddhiPrice);
        syncSiddhi(warmedCart);
      }).catch(function () {});
  }
  function syncSiddhi(cart) {
    var check = drawer.querySelector('[data-siddhi-check]');
    if (!check || !cart) return;
    var found = null;
    cart.items.forEach(function (it) { if (it.handle === siddhiHandle) found = it; });
    check.checked = !!found;
    var span = drawer.querySelector('[data-siddhi] span');
    if (span) {
      if (!span.__dhOrig) span.__dhOrig = span.textContent;
      span.textContent = found ? ('✓ ' + (found.variant_title || 'Siddhi') + ' — tap to change') : span.__dhOrig;
    }
    var pl = drawer.querySelector('[data-siddhi-price]');
    if (pl) {
      if (found) pl.textContent = formatMoney(found.final_line_price);
      else if (siddhiPrice) pl.textContent = 'from ' + formatMoney(siddhiPrice);
    }
  }

  /* Keep service details tied to the current cart, including removals.
     GoKwik receives cart attributes; Shopify also retains line properties. */
  var syncingServiceAttributes = false, serviceSyncPending = false;
  function syncServiceAttributes(cart) {
    if (syncingServiceAttributes) { serviceSyncPending = true; return; }
    var wanted = {}, changes = {}, reportBlocks = [], hasMatching = false, hasMuhurat = false;
    (cart.items || []).forEach(function(it){
      var props = it.properties || {};
      var lines = Object.keys(props).filter(function(k){return k.charAt(0)!=='_' && props[k];}).map(function(k){return k+': '+props[k];});
      if (props.Puja) wanted['Puja booking · '+it.key] = lines.join(' | ');
      if (it.product_type === 'Astrology Report' && lines.length) {
        reportBlocks.push('▶ '+it.product_title+'\n'+lines.join('\n'));
        var label = ((it.handle||'')+' '+(it.product_title||'')).toLowerCase();
        if (/match|milan/.test(label)) hasMatching = true;
        if (/vivah|muhurat|muhurt/.test(label)) hasMuhurat = true;
      }
    });
    Object.keys(cart.attributes || {}).forEach(function(k){
      if (k.indexOf('Puja booking · ')===0 && !wanted[k]) wanted[k]='';
    });
    wanted['Report Details'] = reportBlocks.join(' | ').replace(/\n/g, ', ');
    if (!hasMatching && (cart.attributes||{})['Kundli Matching Details']) wanted['Kundli Matching Details']='';
    if (!hasMuhurat && (cart.attributes||{})['Vivah Muhurat Details']) wanted['Vivah Muhurat Details']='';
    Object.keys(wanted).forEach(function(k){if(((cart.attributes||{})[k]||'')!==wanted[k])changes[k]=wanted[k];});
    var marker = '——— REPORT DETAILS ———';
    var oldNote = cart.note || '', baseNote = oldNote.split(marker)[0].replace(/\s+$/, '');
    var note = reportBlocks.length ? (baseNote ? baseNote+'\n\n' : '')+marker+'\n'+reportBlocks.join('\n\n') : baseNote;
    var payload = {attributes:changes};
    if ((reportBlocks.length || oldNote.indexOf(marker)>-1) && note!==oldNote) payload.note=note;
    if (!Object.keys(changes).length && !Object.prototype.hasOwnProperty.call(payload,'note')) return;
    syncingServiceAttributes=true;
    function done(){
      syncingServiceAttributes=false;
      if (serviceSyncPending) {
        serviceSyncPending=false;
        fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(syncServiceAttributes).catch(function(){});
      }
    }
    fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)}).then(done,done);
  }

  function render(cart) {
    lastTotalCents = cart.total_price;
    updateCounts(Math.max(0, cart.item_count + inflight));
    var full = cart.item_count > 0;
    drawer.querySelectorAll('[data-when-full]').forEach(function (el) { el.hidden = !full; });
    if (!full) {
      itemsEl.innerHTML = '';
      emptyEl.hidden = false;
      footerEl.hidden = true;
    } else {
      paintLines(cart);
      emptyEl.hidden = true;
      footerEl.hidden = false;
      if (subtotalEl) subtotalEl.textContent = formatMoney(Math.max(0, cart.total_price - stealSavings(cart)));
      summarize(cart);
      ensureMeta(cart);
    }
    updateCombo(cart.total_price);
    updateSteal(normalSubtotal(cart));
    renderStealRail(cart);
    updateCheckoutGate(cart);
    renderFBT(cart);
    syncSiddhi(cart);
    clampSteal(cart);
    syncReportFee(cart);
    syncServiceAttributes(cart);
    warmStealCode(cart);
    try { document.dispatchEvent(new CustomEvent('dh:cart', { detail: cart })); } catch (e) {}
  }

  /* Whenever the cart contains a Steal Deal line, keep Shopify's discount cookie fresh
     with the steal code so GoKwik checkout picks it up automatically and the 30% shown
     in the drawer carries through to payment (applies only to the steal products —
     the Shopify code is scoped to the Steal Deal product list, not the whole order).
     Throttled to once a minute; refreshes on every cart change and page load. */
  var lastStealWarm = 0;
  function warmStealCode(cart) {
    if (!hasStealItems(cart)) return;
    var now = Date.now();
    if (now - lastStealWarm < 60000) return;
    lastStealWarm = now;
    fetch('/discount/' + STEAL_CODE, { credentials: 'same-origin' }).catch(function () {});
  }

  function boot() {
    if (booted) return;
    booted = true;
    loadFBT();
    initSiddhi();
    if (stealThreshold <= 0) loadSteal();
  }

  /* ---------- optimistic add ---------- */
  function optimisticAdd(form) {
    var ctx = form.closest('.product-card') || form.closest('.pdp-info') || document;
    var titleEl = ctx.querySelector('.product-card__title') || document.querySelector('.pdp-info h1');
    var imgEl = ctx.querySelector('.product-card__media img') || document.getElementById('pdp-main-img');
    var priceEl = ctx.querySelector('.product-card__price .now');
    var qtyInput = form.querySelector('[name="quantity"]');
    var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    var title = titleEl ? titleEl.textContent.trim() : 'Item';
    var img = imgEl ? imgEl.getAttribute('src') : '';
    var priceCents = 0;
    if (priceEl) {
      var digits = priceEl.textContent.replace(/[^0-9.]/g, '');
      priceCents = Math.round(parseFloat(digits || '0') * 100) * qty;
    }
    emptyEl.hidden = true;
    footerEl.hidden = false;
    var html = '' +
      '<div class="cart-line is-pending" data-optimistic>' +
        (img ? '<img class="cart-line__img" src="' + imgThumb(img) + '" alt="" width="64" height="64">' : '<span class="cart-line__img"></span>') +
        '<div class="cart-line__info">' +
          '<span class="cart-line__title">' + esc(title) + '</span>' +
          '<div class="cart-line__row">' +
            (priceCents ? '<span class="cart-line__price">' + formatMoney(priceCents) + '</span>' : '<span class="cart-line__price">&hellip;</span>') +
            '<span class="qty"><button type="button" disabled>&minus;</button><span>' + qty + '</span><button type="button" disabled>+</button></span>' +
          '</div>' +
        '</div>' +
      '</div>';
    itemsEl.insertAdjacentHTML('afterbegin', html);
  }
  function clearOptimistic() {
    itemsEl.querySelectorAll('[data-optimistic]').forEach(function (n) { n.remove(); });
  }

  /* ---------- fast adds (Oct 2026) ----------
     1. The header count changes the moment Add (or + / −) is tapped; changes still on their way are
        kept in `inflight`, so the count never jumps back while several of them run.
     2. Shopify sends the updated cart back with the add itself: every add asks for the
        "dh-cart-json" section (sections/dh-cart-json.liquid = {{ cart | json }}), so an add is one
        request instead of /cart/add.js followed by /cart.js. If that section is missing the code
        simply falls back to /cart.js, exactly as before. Checkout, GoKwik and the gift/fee rules are
        untouched: render() runs on the same cart object as before. */
  var CART_SECTION = 'dh-cart-json';
  var startCount = null;
  function cartFrom(res) {
    try {
      var html = res && res.sections && res.sections[CART_SECTION];
      if (!html) return null;
      var cart = JSON.parse(html.slice(html.indexOf('>', html.indexOf('data-dh-cart')) + 1, html.lastIndexOf('</script>')));
      if (!cart || !cart.items || typeof cart.item_count === 'undefined') return null;
      /* Liquid's cart JSON has no discount_codes / token: keep the ones from the last full cart,
         so scripts listening to 'dh:cart' (gift and code rules) see the same fields as always. */
      var ref = lastFull || warmedCart;
      if (!cart.discount_codes) cart.discount_codes = (ref && ref.discount_codes) || [];
      if (!cart.token && ref && ref.token) cart.token = ref.token;
      try { Object.defineProperty(cart, '__dhPartial', { value: true }); } catch (e) {}
      return cart;
    } catch (e) { return null; }
  }
  function pending(n) {
    inflight += n;
    if (!warmedCart && startCount === null) {
      var el = document.querySelector('[data-cart-count], .header-cart-count');
      startCount = el ? (parseInt(el.textContent, 10) || 0) : 0;
    }
    updateCounts(Math.max(0, (warmedCart ? warmedCart.item_count : startCount) + inflight));
  }
  function settle(n) { inflight -= n; }
  /* a cart that arrived some other way (e.g. with a Divine Picks add) */
  function apply(cart) {
    if (!cart || !cart.items || typeof cart.item_count === 'undefined') return;
    commit(cart, ++opSeq);
    if (queued > 0) refresh(); /* a drawer request is still running: read the final cart after it */
  }
  window.DivineCart.apply = apply;
  window.DivineCart.pending = pending;
  window.DivineCart.settle = settle;
  window.DivineCart.cartFrom = cartFrom;
  window.DivineCart.section = CART_SECTION;

  /* ---------- API (serialized) ---------- */
  function refresh() {
    return enqueue(function () {
      var seq = ++opSeq;
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { return commit(cart, seq); });
    });
  }
  function changeQty(key, qty, lineEl) {
    if (lineEl) {
      if (qty <= 0) { lineEl.style.opacity = '0.4'; }
      else { var n = lineEl.querySelector('.qty > span'); if (n) n.textContent = qty; }
    }
    return enqueue(function () {
      var seq = ++opSeq;
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); })
        .then(function (cart) { return commit(cart, seq); })
        .catch(function () {
          var seq2 = ++opSeq;
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) { return commit(cart, seq2); });
        });
    });
  }
  function addToCart(form) {
    if (window.__dhRashiTrio && !window.__dhRashiTrio.checkForm(form)) return;
    openCart();
    optimisticAdd(form);
    var data = new FormData(form);
    var units = parseInt(data.get('quantity'), 10) || 1, settled = false;
    function done() { if (!settled) { settled = true; settle(units); } }
    pending(units);
    data.append('sections', CART_SECTION);
    return enqueue(function () {
      var seq = ++opSeq;
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: data })
        .then(function (r) {
          if (!r.ok) { return r.json().then(function (e) { throw e; }); }
          return r.json();
        })
        .then(function (res) {
          done();
          var cart = cartFrom(res);
          if (cart) { clearOptimistic(); return commit(cart, ++opSeq); }
          var seq2 = ++opSeq;
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) { clearOptimistic(); return commit(cart, seq2); });
        })
        .catch(function (err) {
          done();
          clearOptimistic();
          showCartNotice((err && (err.description || err.message)) || 'Couldn’t add this item — it may be out of stock.');
          var seq3 = ++opSeq;
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) { return commit(cart, seq3); });
        });
    });
  }
  function addVariant(id, btn, props) {
    if (window.__dhRashiTrio && !window.__dhRashiTrio.checkItem({ id: id, properties: props }, null)) return;
    if (btn) {
      if (btn.disabled) return;
      btn.disabled = true; btn.textContent = 'Adding…';
    }
    var payload = { id: id, quantity: 1, sections: CART_SECTION };
    if (props) payload.properties = props;
    var settled = false;
    function done() { if (!settled) { settled = true; settle(1); } }
    pending(1);
    return enqueue(function () {
      var seq = ++opSeq;
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (r) {
          if (!r.ok) { return r.json().then(function (e) { throw e; }); }
          return r.json();
        })
        .then(function (res) {
          done();
          var direct = cartFrom(res);
          var seq2 = ++opSeq;
          return (direct ? Promise.resolve(direct) : fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); }))
            .then(function (cart) {
              commit(cart, seq2);
              if (btn) { btn.textContent = 'Added ✓'; setTimeout(function () { btn.disabled = false; btn.textContent = btn.hasAttribute('data-claim') ? 'Claim Now' : 'Add to Cart'; }, 1400); }
              return cart;
            });
        })
        .catch(function (err) {
          done();
          var msg = (err && err.status === 422) || (err && err.description) ? 'Out of stock' : 'Try again';
          if (btn) { btn.textContent = msg; setTimeout(function () { btn.disabled = false; btn.textContent = btn.hasAttribute('data-claim') ? 'Claim Now' : 'Add to Cart'; }, 1800); }
          var seq3 = ++opSeq;
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) { return commit(cart, seq3); });
        });
    });
  }

  /* ---------- events ---------- */
  document.addEventListener('click', function (e) {
    /* Checkout gate (steal items without qualifying regular items). */
    var ckBtn = e.target.closest('[data-cart-checkout]');
    if (ckBtn && warmedCart && (stealBlocked(warmedCart) || belowMin(warmedCart))) {
      e.preventDefault();
      e.stopImmediatePropagation();
      updateCheckoutGate(warmedCart);
      var warn = drawer.querySelector('[data-steal-warn]');
      if (warn) {
        warn.hidden = false;
        warn.style.animation = 'none';
        void warn.offsetWidth;
        warn.style.animation = 'dhwarnflash .7s ease 2';
      }
      return;
    }

    var toggle = e.target.closest('[data-cart-toggle], a[href$="/cart"], a[href$="/cart/"]');
    if (toggle && !e.target.closest('[data-cart-checkout]')) {
      e.preventDefault();
      openCart();
      if (warmedCart) { render(warmedCart); }
      refresh();
      return;
    }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeCart(); return; }

    if (e.target.closest('[data-offers-open]')) { var sh = drawer.querySelector('[data-offers-sheet]'); if (sh) sh.hidden = false; return; }
    if (e.target.closest('[data-offers-close]')) { var sh2 = drawer.querySelector('[data-offers-sheet]'); if (sh2) sh2.hidden = true; return; }

    var cp = e.target.closest('[data-copy-code]');
    if (cp) {
      var code = cp.getAttribute('data-copy-code');
      try { navigator.clipboard.writeText(code); } catch (err) {}
      var card = cp.closest('.cd2-coupon');
      var top = card ? card.querySelector('.cd2-coupon__top') : null;
      if (top) { top.firstChild.textContent = 'Copied! '; setTimeout(function () { top.firstChild.textContent = 'Coupons'; }, 1400); }
      return;
    }

    if (e.target.closest('[data-pay-toggle]')) {
      var body = drawer.querySelector('[data-pay-body]');
      var ic = drawer.querySelector('[data-pay-icon]');
      if (body) { body.hidden = !body.hidden; if (ic) ic.textContent = body.hidden ? '+' : '✕'; }
      return;
    }
    if (e.target.closest('[data-steal-toggle]')) {
      var sb = drawer.querySelector('[data-steal]');
      if (sb) {
        var hb = sb.querySelector('[data-steal-toggle]');
        if (hb && hb.disabled) return;
        sb.classList.toggle('is-collapsed');
        var collapsed = sb.classList.contains('is-collapsed');
        var subEl = sb.querySelector('[data-steal-sub]');
        if (subEl) {
          if (collapsed) { subEl.textContent = 'Unlocked — ' + STEAL_PCT + '% OFF · tap to view your deals'; subEl.hidden = false; }
          else { subEl.hidden = true; }
        }
        if (!collapsed) loadSteal();
        renderStealRail(warmedCart);
      }
      return;
    }
    var sn = e.target.closest('[data-steal-prev], [data-steal-next]');
    if (sn) {
      var tr = drawer.querySelector('[data-steal-track]');
      if (tr) tr.scrollBy({ left: sn.hasAttribute('data-steal-next') ? 274 : -274, behavior: 'smooth' });
      return;
    }
    var av = e.target.closest('[data-add-variant]');
    if (av) {
      var stealProps = av.hasAttribute('data-steal-item') ? { _steal_deal: String(STEAL_PCT) } : null;
      addVariant(parseInt(av.getAttribute('data-add-variant'), 10), av, stealProps);
      if (stealProps && !sessionStorage.getItem('dh_steal_code_warmed')) {
        try { sessionStorage.setItem('dh_steal_code_warmed', '1'); } catch (_) {}
        fetch('/discount/' + STEAL_CODE, { credentials: 'same-origin' }).catch(function () {});
      }
      return;
    }

    var line = e.target.closest('.cart-line');
    if (line && !line.hasAttribute('data-optimistic')) {
      var key = line.getAttribute('data-key');
      var itByKey = null; ((warmedCart && warmedCart.items) || []).forEach(function (it) { if (it.key === key) itByKey = it; });
      if (itByKey && isFeeLine(itByKey) && hasReports(warmedCart)) return; /* processing fee is locked while a report is in the cart */
      var qtyText = line.querySelector('.qty > span');
      var current = qtyText ? parseInt(qtyText.textContent, 10) : 1;
      if (e.target.closest('[data-qty-up]')) { changeQty(key, current + 1, line); }
      else if (e.target.closest('[data-qty-down]')) { changeQty(key, Math.max(0, current - 1), line); }
      else if (e.target.closest('[data-remove]')) { changeQty(key, 0, line); }
    }
  });

  document.addEventListener('change', function (e) {
    var sc = e.target.closest('[data-siddhi-check]');
    if (!sc) return;
    /* The Siddhi levels popup (snippet dh-siddhi-modal) handles add / switch /
       remove now — revert the toggle to the cart's real state and open it. */
    if (window.DHSiddhi) {
      if (!sc.checked && window.DHSiddhi.remove) { window.DHSiddhi.remove(); return; } /* uncheck = remove, no popup */
      syncSiddhi(warmedCart);
      window.DHSiddhi.open();
      return;
    }
    /* fallback: original single-level behaviour if the popup is unavailable */
    if (sc.checked) {
      if (siddhiVariant) { addVariant(siddhiVariant); }
      else { sc.checked = false; }
    } else if (warmedCart) {
      var ln = null;
      warmedCart.items.forEach(function (it) { if (it.handle === siddhiHandle) ln = it; });
      if (ln) changeQty(ln.key, 0);
    }
  });

  /* Primary interception happens in the inline head guard (theme.liquid), which runs
     before any other script and delegates here via window.__dhATC. The bubble listener
     below is only a fallback for markup rendered without the guard; it skips events the
     guard already handled (defaultPrevented / __dhHandled) so an add can never fire twice. */
  window.__dhATC = addToCart;
  document.addEventListener('submit', function (e) {
    if (e.defaultPrevented || e.__dhHandled) return;
    var form = e.target;
    var action = (form && form.getAttribute) ? (form.getAttribute('action') || '') : '';
    if (action.indexOf('/cart/add') !== -1) {
      e.preventDefault();
      addToCart(form);
    }
  });

  /* An add completed before this script loaded (inline guard fallback, FBT bundle, etc.)
     — render that cart and open the drawer now, so the customer always sees it. */
  if (window.__dhOpenCartOnReady) {
    window.__dhOpenCartOnReady = 0;
    try {
      var pending = window.__dhPendingCart;
      if (pending && typeof pending.item_count !== 'undefined') { warmedCart = pending; render(pending); }
    } catch (e) {}
    openCart();
    refresh();
  }

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });

  if (/\/cart\/?$/.test(window.location.pathname)) {
    document.addEventListener('DOMContentLoaded', function () { openCart(); refresh(); });
  }

  var prewarm = function () { refresh(); };
  if ('requestIdleCallback' in window) { requestIdleCallback(prewarm, { timeout: 2500 }); }
  else { setTimeout(prewarm, 1500); }
})();